// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"charts_wrapper__3ZWx4"};